<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="journals.icon" class="mr-1"></i>
                        {{ journals.title }}
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-3">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Date" label-size="sm">
                                    <b-input-group>
                                        <daterangepicker size="sm" ref="date_at" v-model="date_at" :opens="'right'"
                                            :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                                            :linkedCalendars="false" :single-date-picker="false">
                                        </daterangepicker>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="date_at = {
                                                startDate: null,
                                                endDate: null,
                                            }
                                                ">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="journals.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="ReferenceNo ( Paste List )" label-for="referenceno"
                                    label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Ref" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="referenceno = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>

                <div class="px-3">
                    <!-- {{ journals.offset }} {{ journals.limit }} {{ journals.page }} -->
                    <d-table classdivtable="availtable datatable credit-normal" refid="journals" :icon="journals.icon"
                        :toolbarlibrary="journals.toolbarlibrary" :tools="journals.tools" :icons="journals.icons"
                        :badges="journals.badges" :fields="journals.fields" :items="journals.items"
                        :busy="journals.busy" :offset="journals.offset" :limit="journals.limit"
                        :downloaded="journals.downloaded" :page="journals.page" :showpages="true" @load="journals_load"
                        @click="journals_click" @select="journals_select">
                    </d-table>

                </div>
            </div>

            <div v-show="component">
                <component :is="component" :value="item" :selection="journals.selected"
                    @discard="journals_click('discard')"></component>
            </div>

            <b-row class="px-3">
                <b-col>
                    <b-alert :show="message ? true : false" variant="warning">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                <span v-html="message"></span></b-col></b-row>
                    </b-alert></b-col>
            </b-row>

        </b-card>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import JournalEdit from "./Components/JournalEdit.vue";

export default {
    name: "Journals",
    components: { JournalEdit },
    async mounted() {
        await this.accessdenied();
        await this.journals_load(0);
    },
    watch: {
        async date_at() {
            console.log('watch date_at')
            await this.journals_load(0);
        },

        async description() {
            console.log('watch description')
            await this.journals_load(0);
        },
        async referenceno() {
            console.log('watch referenceno', this.referenceno)
            if (this.referenceno.length == 0) {
                this.date_at = { startDate: this.$moment().startOf("month").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
            } else {
                this.date_at = { startDate: null, endDate: null }
            }
            await this.journals_load(0);
        },


    },
    data() {
        return {
            busy: false,
            readonly: false,
            showfilter: false,
            message: null,
            date_at: {
                startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
                endDate: this.$moment().endOf("year").add(3, 'month').format("YYYY-MM-DD"),
            },
            description: null,
            referenceno: [],
            item: {},
            journals: {
                title: "Journals",
                icon: "fa fa-pencil-square-o text-primary",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                denied: [],
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-exchange text-orange",
                        position: "toolbar,actions",
                        action: "reverse",
                        label: "Reverse",
                        component: {
                            name: "",
                        },
                    },


                ],
                tools:
                    "go,filter,download,clipboard,add,edit,deleteconfirm,reverse",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "date_at",
                        label: "Date",
                        sortable: true,
                        class: "text-center nowrap",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(true)
                                    .format("DD/MM/YY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "referenceno",
                        label: "ReferenceNo",
                        sortable: true,
                        class: "",
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                        class: "",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },

                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                items: [],
                downloaded: [],
                badges: [
                    // {
                    //     key: "confirmno",
                    //     type: "pill",
                    //     class: "orange",
                    // },               
                ],

            },
            component: null,
        };
    },
    computed: {
        ...mapGetters(["window"]),
    },
    methods: {
        accessdenied() {
            this.journals.denied = [];
            if (!this.user.permissions.includes("journals.delete")) {
                this.journals.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("journals.save")) {
                this.journals.denied.push("save");
            }
        },

        async journals_load(offset, limit, page) {

            console.log('journals_load', offset, limit, page)
            this.message = null

            let state = this.journals

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true

            let variables = {
                offset: state.offset,
                limit: state.limit,

                date_at: [
                    this.date_at.startDate
                        ? this.$moment(this.date_at.startDate).format("YYYY-MM-DD")
                        : null,
                    this.date_at.endDate
                        ? this.$moment(this.date_at.endDate).format("YYYY-MM-DD")
                        : null,
                ],
                description: this.description,
                referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
            };

            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query journals(             
                        $offset: Int
                        $limit: Int
                        $date_at: [String]
                        $description: String   
                        $referenceno: String                  
                    ) {
                            journals(                 
                            offset: $offset
                            limit: $limit
                            date_at: $date_at
                            description: $description  
                            referenceno: $referenceno                                         
                            ) {
                                id
                                type
                                date_at
                                referenceno
                                description
                                amount 
                                updated_at
                                updated_by
                                rows
                            }
                        }
                        `,
                    variables,
                });

                // USE LOCAL VARIABLE
                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.journals
                } else {
                    state.items = response.data.journals;
                }


            } catch (error) {
                console.log(error);
            }

            state.busy = false;

        },

        async journals_click(a, ss) {

            let state = this.journals

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.journals_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.journals_load(0);
                    break;
                case "add":
                    this.journal_add();
                    this.component = "JournalEdit";
                    break;
                case "edit":
                    if (ss.length > 0) {
                        await this.journal_load(ss);
                        this.component = "JournalEdit";
                    }
                    break;
                case "go":
                    this.component = null;
                    await this.journals_load(0);
                    break;

                case "delete":
                    if (ss.length > 0) {
                        await this.journals_delete(ss);
                    }
                    break;

                case "reverse":
                    if (ss[ss.length - 1].referenceno.slice(0, 2) == 'RG') {
                        this.message = "You cannot reverse an already reversed Journal."
                        return
                    }

                    if (await this.$bvModal.msgBoxConfirm('Are you sure you want to reverse journal ' + ss[ss.length - 1].referenceno + '?',
                        {
                            title: 'Please confirm reverse action.',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            okTitle: 'Yes',
                            cancelTitle: 'No',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                        })) {

                        await this.journals_reverse(ss)

                    }

                    break;

            }
        },
        async journals_select(ss, tools) {
            this.message = null
            let state = this.journals

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "clipboard",
                    "add",
                    "download",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1                           
                enabled = ["edit", "reverse"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1

                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async journals_delete(ss) {
            console.log("journals_delete", ss);

            let state = this.journals;

            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.referenceno });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation journals_delete($rows: [Journal_input]) {
                            journals_delete(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false

            await this.journals_load(0);
        },

        async journals_reverse(ss) {
            console.log("journals_reverse", ss);

            let state = this.journals;

            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                if (v.referenceno.slice(0, 2) == 'RG') {
                    this.message = "You cannot reverse an already reversed Journal."
                    return
                }
                rows.push({ referenceno: v.referenceno });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation journals_reverse($rows: [Journal_input]) {
                            journals_reverse(rows: $rows) {
                                id
                            }
                        }
                        `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            state.busy = false

            await this.journals_load(0);
        },

        journal_add() {
            this.item = {
                id: "",
                type: "GLJ",
                date_at: this.$moment().subtract(1, 'months').endOf('month').toDate(),
                description: "",
                referenceno: "JG*new*",
                items: [
                    {
                        id: "",
                        type: "GLJ",
                        referenceno: "JG*new*",
                        nlcode: null,
                        debit: (0).toFixed(2),
                        credit: (0).toFixed(2)
                    }
                ]
            }
        },
        async journal_load(ss) {

            let state = this.journals

            state.busy = true

            let variables = {
                referenceno: ss[0].referenceno
            };
            console.log("variables", variables);

            this.busy = true
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query journals(                      
                            $referenceno: String                  
                        ) {
                            journals(                 
                                referenceno: $referenceno                                         
                            ) {
                                id
                                entry
                                type
                                date_at
                                referenceno
                                description
                                items {
                                    id
                                    entry
                                    type
                                    date_at
                                    referenceno
                                    nlcode
                                    description
                                    credit
                                    debit
                                }
                                created_by
                                created_at
                                updated_by
                                updated_at
                            }
                            }
                            `,
                    variables,

                });


                this.item = response.data.journals[0]

            } catch (error) {
                console.log(error);
            }

            state.busy = false

        }
    },
};
</script>